"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useToast = void 0;

var _tslib = require("tslib");

var _context = require("./context");

var _lodash = require("lodash");

var useToast = function useToast() {
  var toastDispatch = (0, _context.useToastDispatch)();

  var addToast = function addToast(toast) {
    var id = Number((0, _lodash.uniqueId)());
    toastDispatch({
      type: 'ADD_TOAST',
      toast: (0, _tslib.__assign)({
        id: id
      }, toast)
    });
  };

  var deleteToast = function deleteToast(id) {
    toastDispatch({
      type: 'DELETE_TOAST',
      id: id
    });
  };

  return {
    addToast: addToast,
    deleteToast: deleteToast
  };
};

exports.useToast = useToast;